import * as React from 'react';
export default class Footer extends React.Component<any, any> {
	public render(): React.ReactNode {
		return <div className="footer" style={{ textAlign: 'center', fontSize: '0.5em' }} />;
	}
}
